export const apiKey = "HqHNEG8dBsxJhzxNsB07NMNs22LEcwfV";
